export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              精选推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              编辑团队每日甄选，优质影视一网打尽
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {/* Card 1 */}
            <div className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20portrait%2C%20dramatic%20sci-fi%20astronaut%20in%20space%20suit%2C%20warm%20golden%20nebula%20background%2C%20cinematic%20lighting%2C%20professional%20movie%20poster%20composition%2C%20high%20contrast%2C%20clean%20background&width=600&height=800&seq=card-01&orientation=portrait"
                  alt="《星际征途》- 西瓜影视精选推荐科幻电影"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 px-2 py-1 rounded bg-accent-500 text-background-950 text-[10px] font-bold whitespace-nowrap">
                  9.8
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">《星际征途》</h3>
                <p className="text-xs text-foreground-500 mb-2">科幻冒险 · 2026</p>
                <div className="flex items-center gap-1 text-[10px] text-foreground-400 flex-wrap">
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">蓝光</span>
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">中英双字</span>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20portrait%2C%20mysterious%20detective%20in%20trench%20coat%20under%20rainy%20street%20lamp%2C%20noir%20atmosphere%2C%20warm%20amber%20lighting%2C%20professional%20movie%20poster%20composition%2C%20high%20contrast%2C%20clean%20background&width=600&height=800&seq=card-02&orientation=portrait"
                  alt="《暗夜追踪》- 西瓜影视精选推荐悬疑电影"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 px-2 py-1 rounded bg-accent-500 text-background-950 text-[10px] font-bold whitespace-nowrap">
                  9.6
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">《暗夜追踪》</h3>
                <p className="text-xs text-foreground-500 mb-2">悬疑动作 · 2026</p>
                <div className="flex items-center gap-1 text-[10px] text-foreground-400 flex-wrap">
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">4K</span>
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">中英双字</span>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20portrait%2C%20elegant%20Chinese%20ancient%20warrior%20woman%20in%20flowing%20silk%20dress%2C%20warm%20golden%20lantern%20light%2C%20historical%20drama%20aesthetic%2C%20professional%20movie%20poster%20composition%2C%20soft%20dreamy%20background&width=600&height=800&seq=card-03&orientation=portrait"
                  alt="《大唐风华》- 西瓜影视精选推荐古装剧集"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 px-2 py-1 rounded bg-accent-500 text-background-950 text-[10px] font-bold whitespace-nowrap">
                  9.5
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">《大唐风华》</h3>
                <p className="text-xs text-foreground-500 mb-2">古装历史 · 2026</p>
                <div className="flex items-center gap-1 text-[10px] text-foreground-400 flex-wrap">
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">蓝光</span>
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">国语</span>
                </div>
              </div>
            </div>

            {/* Card 4 */}
            <div className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20portrait%2C%20happy%20Chinese%20family%20laughing%20together%20in%20bright%20modern%20living%20room%2C%20warm%20sunlight%2C%20cheerful%20comedy%20mood%2C%20professional%20movie%20poster%20composition%2C%20clean%20colorful%20background&width=600&height=800&seq=card-04&orientation=portrait"
                  alt="《欢乐一家人》- 西瓜影视精选推荐喜剧剧集"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 px-2 py-1 rounded bg-accent-500 text-background-950 text-[10px] font-bold whitespace-nowrap">
                  9.3
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">《欢乐一家人》</h3>
                <p className="text-xs text-foreground-500 mb-2">家庭喜剧 · 2026</p>
                <div className="flex items-center gap-1 text-[10px] text-foreground-400 flex-wrap">
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">4K</span>
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">国语</span>
                </div>
              </div>
            </div>

            {/* Card 5 */}
            <div className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20portrait%2C%20intense%20survivor%20in%20dark%20underwater%20environment%20with%20dramatic%20light%20rays%2C%20disaster%20movie%20mood%2C%20professional%20movie%20poster%20composition%2C%20high%20contrast%2C%20atmospheric%20deep%20sea%20background&width=600&height=800&seq=card-05&orientation=portrait"
                  alt="《深海危机》- 西瓜影视精选推荐灾难电影"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 px-2 py-1 rounded bg-accent-500 text-background-950 text-[10px] font-bold whitespace-nowrap">
                  9.1
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">《深海危机》</h3>
                <p className="text-xs text-foreground-500 mb-2">灾难惊悚 · 2026</p>
                <div className="flex items-center gap-1 text-[10px] text-foreground-400 flex-wrap">
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">蓝光</span>
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">中英双字</span>
                </div>
              </div>
            </div>

            {/* Card 6 */}
            <div className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20portrait%2C%20young%20Korean%20couple%20in%20romantic%20cherry%20blossom%20scene%2C%20soft%20pastel%20lighting%2C%20sweet%20romance%20drama%20mood%2C%20professional%20movie%20poster%20composition%2C%20dreamy%20pink%20spring%20background&width=600&height=800&seq=card-06&orientation=portrait"
                  alt="《恋之樱花季》- 西瓜影视精选推荐韩剧"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 px-2 py-1 rounded bg-accent-500 text-background-950 text-[10px] font-bold whitespace-nowrap">
                  9.2
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">《恋之樱花季》</h3>
                <p className="text-xs text-foreground-500 mb-2">韩剧浪漫 · 2026</p>
                <div className="flex items-center gap-1 text-[10px] text-foreground-400 flex-wrap">
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">超清</span>
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">中字</span>
                </div>
              </div>
            </div>

            {/* Card 7 */}
            <div className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20portrait%2C%20group%20of%20young%20adults%20in%20urban%20street%20style%2C%20trendy%20youth%20fashion%2C%20warm%20sunset%20golden%20hour%20lighting%2C%20coming-of-age%20drama%20mood%2C%20professional%20movie%20poster%20composition%2C%20clean%20cityscape%20background&width=600&height=800&seq=card-07&orientation=portrait"
                  alt="《青春不散场》- 西瓜影视精选推荐青春剧集"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 px-2 py-1 rounded bg-accent-500 text-background-950 text-[10px] font-bold whitespace-nowrap">
                  8.9
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">《青春不散场》</h3>
                <p className="text-xs text-foreground-500 mb-2">青春校园 · 2026</p>
                <div className="flex items-center gap-1 text-[10px] text-foreground-400 flex-wrap">
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">超清</span>
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">国语</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}